import React from 'react'
import axios from 'axios';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';



function StateRaceTile({ state, race, year }) {


  const [candidates, setCandidates] = useState([]);
  const [votes, setVotes] = useState([0, 0]);

  const getSenateCandidates = async () => {
    axios.get("/api/v1/congress/senateRace/" + state + "/" + year)
      .then((result) => {
        let cans = result.data;
        cans.forEach((c, currentIdx) => {
          axios.get("/api/v1/uservote/votes/30/" + c.id)
            .then((result3) => {
              setVotes(prevVotes =>
                prevVotes.map((vote, index) =>
                  index == currentIdx ? result3.data : vote
                ));
            })

        })
        setCandidates(cans);
      })
      .catch((err) => console.log(err));
  };



  useEffect(() => {
    getSenateCandidates();
  }, []);

  return (
    <div border="1">
      <div className="content-card links">
        <a href={"/senate/2026/" + state}>
          <div className="content-image-small">
            <div><center>{state}</center></div>
            <img src={"/graphics/flags/Flag_of_" + state.replace(' ', '_') + ".svg"} alt={state} />
          </div>
        </a>

        <div className="content-details">
          {candidates.map((candidate, index) => (
            <a href={"/senate/2026/" + state} key={index}>
              <div className="content-text">{candidate.name} ({candidate.party}) <img src="/graphics/icons/hand-thumbs-up.svg" alt="like" /> &times; {votes[index]}
              </div>
            </a>
          ))}
        </div>

      </div>
    </div >
  )
}

export default StateRaceTile
